<template>
    <div id="loading-screen" v-if="getLoadingScreen">

        <div class="self-building-square-spinner">
            <div class="square"></div>
            <div class="square"></div>
            <div class="square"></div>
            <div class="square clear"></div>
            <div class="square"></div>
            <div class="square"></div>
            <div class="square clear"></div>
            <div class="square"></div>
            <div class="square"></div>
        </div>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        props: {
            animationDuration: {
                type: Number,
                default: 1000
            },
            size: {
                type: Number,
                default: 60
            },
            color: {
                type: String,
                default: 'red'
            }
        },


        data() {
            return {}
        },
        methods: {},
        computed: {
            ...mapGetters(['getLoadingScreen']),

            spinnerStyle () {
                return {
                    height: `${this.size}px`,
                    width: `${this.size}px`
                }
            },

            circleStyle () {
                return {
                    color: this.color,
                    fontSize: `${this.size * 0.24}px`
                }
            },

            lineStyle () {
                return {
                    animationDuration: `${this.animationDuration}ms`,
                    borderLeftWidth: `${this.size / 25}px`,
                    borderTopWidth: `${this.size / 25}px`,
                    borderLeftColor: this.color
                }
            }
        },
        watch: {

        },
        created() {

        }
    }
</script>
<style scoped lang="scss">

    #loading-screen {
        z-index: 1203123123;
        background: rgba(0,0,0,0.6);
        position: fixed;
        top: 0;
        width: 100px;
        left: 0;
        min-width: 100vw;
        min-height: 100vh;
    }

    .self-building-square-spinner, .self-building-square-spinner * {
        box-sizing: border-box;
    }

    .self-building-square-spinner {
        height: 40px;
        width: 40px;
        //top: calc( -10px * 2 / 3);
        position: absolute;
        margin: auto;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }

    .self-building-square-spinner .square {
        height: 10px;
        width: 10px;
        top: calc( -10px * 2 / 3);
        margin-right: calc(10px / 3);
        margin-top: calc(10px / 3);
        background: #ff1d5e;
        float: left;
        position:relative;
        opacity: 0;
        animation: self-building-square-spinner 6s infinite;
    }

    .self-building-square-spinner .square:nth-child(1) {
        animation-delay: calc(300ms * 6);
        background: #87faa4;
    }

    .self-building-square-spinner .square:nth-child(2) {
        animation-delay: calc(300ms * 7);
        background: #78f5ae;
    }

    .self-building-square-spinner .square:nth-child(3) {
        animation-delay: calc(300ms * 8);
        background: #67eeba;
    }

    .self-building-square-spinner .square:nth-child(4) {
        animation-delay: calc(300ms * 3);
        background: #53e7c7;
    }

    .self-building-square-spinner .square:nth-child(5) {
        animation-delay: calc(300ms * 4);
        background: #3fe0d5;
    }

    .self-building-square-spinner .square:nth-child(6) {
        animation-delay: calc(300ms * 5);
        background: #2bd9e2;
    }

    .self-building-square-spinner .square:nth-child(7) {
        animation-delay: calc(300ms * 0);
        background: #19d2ee;
    }

    .self-building-square-spinner .square:nth-child(8) {
        animation-delay: calc(300ms * 1);
        background: #0bcdf8;
    }

    .self-building-square-spinner .square:nth-child(9) {
        animation-delay: calc(300ms * 2);
        background: #00c9ff;
    }

    .self-building-square-spinner .clear{
        clear: both;
    }

    @keyframes self-building-square-spinner {
        0% {
            opacity: 0;
        }
        5% {
            opacity: 1;
            top: 0;
        }
        50.9% {
            opacity: 1;
            top: 0;
        }
        55.9% {
            opacity: 0;
            top: inherit;
        }
    }

</style>